export default {
    ABOUT_DEVICE_BTN_BACK: 'aboutMyDeviceBtnBack',
    ABOUT_DEVICE_BTN_CHARGER: 'aboutMyDeviceBtnChargerSection',
    ABOUT_DEVICE_BTN_FWU_CHECK_CHARGER: 'aboutMyDeviceBtnCheckChargerFirmwareUpdate',
    ABOUT_DEVICE_BTN_FWU_CHECK_HOLDER: 'aboutMyDeviceBtnCheckHolderFirmwareUpdate',
    ABOUT_DEVICE_BTN_HOLDER: 'aboutMyDeviceBtnHolderSection',
    ABOUT_DEVICE_BTN_REGISTER: 'aboutMyDeviceBtnRegisterDevice',
    ABOUT_DEVICE_BTN_UNREGISTER: 'aboutMyDeviceBtnUnregisterDevice',
    ABOUT_MY_DEVICE_BTN_UNREGISTER_HOLDER: 'aboutMyDeviceBtnUnregisterHolder',
    ABOUT_DEVICE_BTN_UNREGISTER_CONFIRM: 'aboutMyDeviceUnregisterBtnConfirm',
    ABOUT_MY_DEVICE_UNREGISTER_BTN_CANCEL: 'aboutMyDeviceUnregisterBtnCancel',
    ABOUT_DEVICE_CHARGER_CODENTIFY: 'aboutMyDeviceTextChargerCodentify',
    ABOUT_DEVICE_PAGE: 'aboutMyDevicePage',
    ABOUT_DEVICE_PAGE_UNREGISTER_POPUP: 'aboutMyDeviceBtnUnregisterPopup',
    ABOUT_DEVICE_SUCC_DEACTIV_NOTIF: 'aboutMyDeviceSuccDeactivationNotification',
    ABOUT_DEVICE_SUCC_REG_NOTIF: 'aboutMyDeviceSuccRegisterNotification',
    ABOUT_DEVICE_SUCC_UNREG_NOTIF: 'aboutMyDeviceSuccUnregisterNotification',
    ABOUT_DEVICE_SUCC_HOLDER_UNREG_NOTIF: 'aboutMyDeviceSuccHolderUnregisterNotification',
    AUTO_START_SETTINGS_BTN: 'statusAutoStartWhenStickInserted',
    ACTIVATION_FLOW_REGISTERING_TITLE: 'activationFlowTitleRegistering',
    AGE_VERIFICATION_PAGE: 'verifyAgePage',
    AGE_VERIFICATION_FAILED_BTN_GO_TO_WEB: 'ageVerificationFailedBtnGoToWeb',
    APP_INTRO_PAGE_NATIVE_APP_DOWNLOAD_BTN: 'compatibilityBrowserBtnDownloadNativeApp',
    AUTO_START_MODE_POPUP: 'autoStartPopup',
    AUTO_START_WHEN_STICK_TEXT: 'autoStartWhenStickBtn',
    AUTOSTART_BUTTON_FALSE: 'autoStartBtnFalse',
    AUTOSTART_BUTTON_TRUE: 'autoStartBtnTrue',
    BROWSER_COMPATIBLE_PAGE: 'compatibilityBrowserPage',
    CAROUSEL_DOT: 'carouselItem',
    CLEANING_BTN_START: 'cleaningBtnStart',
    CLEANING_MODE_POPUP: 'cleaningPopup',
    CLEANING_TEXT_CLEANING: 'cleaningTextCleaning',
    CLEANING_NOTIFICATION_INSERT_HOLDER: 'cleaningNotificationInsertHolder',
    CLEANING_NOTIFICATION_RECENTLY_CLEANED: 'cleaningNotificationRecentlyCleaned',
    CLEANING_NOTIFICATION_SUCCESS_CLEANED: 'cleaningNotificationSuccessCleaned',
    COMPATIBILITY_BROWSER_BTN_CONTINUE: 'compatibilityBrowserBtnContinue',
    DATA_COLLECTION_PAGE: 'dataCollectionPage',
    DEVICE_LIST_BTN_ACTIVATE: 'deviceListBtnActivate',
    DEVICE_LIST_BTN_ADD_NEW: 'deviceListBtnAddNew',
    DEVICE_LIST_BTN_LOCK: 'deviceListBtnLock',
    DEVICE_LIST_BTN_PAIR: 'deviceListBtnPairDevice',
    DEVICE_LIST_BTN_PAIRING_IFO_POPUP_PAIR_DEVICE: 'deviceListBtnPairingInfoPopupPairDevice',
    DEVICE_LIST_BTN_CAROUSEL_PREV: 'deviceListBtnCarouselPrev',
    DEVICE_LIST_BTN_CAROUSEL_NEXT: 'deviceListBtnCarouselNext',
    DEVICE_LIST_TEXT_BATTERY_LEVEL: 'deviceListTextBatteryLevel',
    DEVICE_LIST_TEXT_DEVICE_NAME: 'deviceListTextDeviceName',
    DEVICE_LIST_TEXT_CONNECTION_STATUS: 'deviceListTextConnectionStatus',
    DEVICE_LIST_BTN_NO_DEVICE_LEARN_MORE: 'deviceListBtnNoDeviceLearnMore',
    DEVICE_LIST_BTN_FINISH_DIAGNOSTIC: 'deviceListBtnFinishDiagnostic',
    DEVICE_LIST_BTN_ELIGIBLE_FOR_TRADE: 'deviceListBtnEligibleForTrade',
    CONNECTION_SELECTION_BTN_SET_UP_DEVICE_BLE: 'connectionSelectionBtnSetUpDeviceBle',
    CONNECTION_SELECTION_BTN_SET_UP_DEVICE_USB: 'connectionSelectionBtnSetUpDeviceUsb',
    CONNECTION_SELECTION_BTN_BACK: 'connectionSelectionBtnBack',
    CONNECTION_SELECTION_BTN_DIFFERENT_METHOD_SET_UP: 'connectionSelectionBtnDifferentMethodSetUp',
    CONNECTION_SELECTION_BTN_CONNECT_USB: 'connectionSelectionBtnConnectUsb',
    DEVICE_LIST_BTN_SETTINGS: 'deviceListBtnSettings',
    DEVICE_LIST_BTN_AVAILABLE_FWU: 'deviceListBtnAvailableFirmware',
    DEVICE_LIST_BTN_AVAILABLE_FWU_CLOSE_BTN: 'deviceListBtnAvailableFirmwareCloseBtn',
    DEVICE_LIST_BTN_SETUP_NEW_DEVICE: 'deviceListBtnSetUpNewDevice',
    DEVICE_LIST_BTN_UNLOCK: 'deviceListBtnUnlock',
    DEVICE_LIST_DEVICE_CORTEZ: 'pairingSequenceBtnSelectCortez',
    DEVICE_LIST_DEVICE_MULTI: 'pairingSequenceBtnSelectMulti',
    DEVICE_LIST_DEVICE_ORIGINAL_ONE: 'pairingSequenceBtnSelectOriginalsOne',
    DEVICE_LIST_DEVICE_ORIGINALS_DUO: 'pairingSequenceBtnSelectOriginalsDuo',
    DEVICE_LIST_DEVICE_ORDINARY: 'pairingSequenceBtnSelectOrdinary',
    DEVICE_LIST_DEVICE_SOYUZ: 'pairingSequenceBtnSelectSoyuz',
    DEVICE_LIST_DEVICE_ARIANE: 'pairingSequenceBtnSelectAriane',
    DEVICE_LIST_DEVICE_HERMES_PRIME: 'pairingSequenceBtnSelectHermesPrime',
    DEVICE_LIST_DEVICE_HERMES_MID: 'pairingSequenceBtnSelectHermesMid',
    DEVICE_LIST_DEVICE_HERMES_BETA: 'pairingSequenceBtnSelectHermesBeta',
    DEVICE_LIST_DEVICE_JUNO: 'pairingSequenceBtnSelectJuno',
    DEVICE_LIST_DEVICE_ALPHA: 'pairingSequenceBtnSelectAlpha',
    DEVICE_LIST_ITEM: 'DeviceListItem',
    DEVICE_LIST_PAGE: 'deviceListPage',
    DEVICE_SETTINGS_BTN_MANUAL_RESET: 'deviceSettingsBtnManualReset',
    DEVICE_SETTINGS_BTN_ABOUT: 'deviceSettingsBtnAboutMyDevice',
    DEVICE_SETTINGS_BTN_AUTO_START: 'deviceSettingsBtnAutoStart',
    DEVICE_SETTINGS_BTN_FLEX_PUFF: 'deviceSettingsBtnFlexPuff',
    DEVICE_SETTINGS_BTN_BACK: 'deviceSettingsBtnBack',
    DEVICE_SETTINGS_BTN_CLEANING: 'deviceSettingsBtnCleaning',
    DEVICE_SETTINGS_BTN_DIAGNOSTIC: 'deviceSettingsBtnDiagnostic',
    DEVICE_SETTINGS_BTN_ADVANCED_DIAGNOSTICS: 'deviceSettingsBtnAdvancedDiagnostics',
    DEVICE_SETTINGS_BTN_AEM: 'deviceSettingsBtnAem',
    DEVICE_SETTINGS_BTN_PAUSE_MODE: 'deviceSettingsBtnPauseMode',
    DEVICE_SETTINGS_BTN_LED: 'deviceSettingsBtnLed',
    DEVICE_SETTINGS_BTN_LEGALS: 'deviceSettingsBtnLegalAndPolicy',
    DEVICE_SETTINGS_BTN_LOCATE: 'deviceSettingsBtnLocate',
    DEVICE_SETTINGS_BTN_LOCK: 'deviceSettingsBtnLock',
    DEVICE_SETTINGS_BTN_PREFERENCE_CENTER: 'deviceSettingsBtnPreferenceCenter',
    DEVICE_SETTINGS_BTN_RENAME: 'deviceSettingsBtnRename',
    DEVICE_SETTINGS_BTN_RESP_DRAW: 'deviceSettingsBtnResponsiveDraw',
    DEVICE_SETTINGS_BTN_STATUS_GESTURE: 'deviceSettingsBtnStatusGesture',
    TIPS_AND_TUTORIALS_BTN_MORE: 'tipsAndTutorialsBtnMore',
    DEVICE_SETTINGS_BTN_UNLOCK: 'deviceSettingsBtnUnlock',
    DEVICE_SETTINGS_BTN_UNPAIR: 'deviceSettingsBtnUnpairDevice',
    DEVICE_SETTINGS_BTN_VAPE_CLOUD_SIZE: 'deviceSettingsBtnVapeCloudSize',
    DEVICE_SETTINGS_BTN_VIBRATION: 'deviceSettingsBtnVibration',
    DEVICE_SETTINGS_BTN_SAVE: 'deviceSettingsBtnSave',
    DEVICE_SETTINGS_BTN_CLOSE: 'deviceSettingsBtnClose',
    DEVICE_SETTINGS_DEVICE_NAME: 'deviceSettingsTextDeviceName',
    DEVICE_SETTINGS_LOCK_SUCC_NOTIFIC: 'deviceSettingsLockSuccNotific',
    DEVICE_SETTINGS_UNLOCK_SUCC_NOTIFIC: 'deviceSettingsUnlockSuccNotific',
    DEVICE_SETTINGS_DIAGNOSTIC_NO_ERRORS_NOTIFICATION: 'deviceSettingsDiagnosticNoErrorsNotification',
    DEVICE_SETTINGS_DIAGNOSTIC_NOT_AVAILABLE_NOTIFICATION: 'deviceSettingsDiagnosticNotAvailableNotification',
    DEVICE_SETTINGS_STORE_LOCATOR: 'deviceSettingsBtnShop',
    DEVICE_SETTINGS_UNPAIR_BUTTON_TEXT_BTN_NO: 'deviceSettingsUnpairBtnNo',
    DEVICE_SETTINGS_UNPAIR_BUTTON_TEXT_BTN_YES: 'deviceSettingsUnpairBtnYes',
    DEVICE_SETTINGS_BTN_USAGE: 'deviceSettingsBtnUsage',
    DEVICE_SETTINGS_BTN_TRADE_IN_BANNER: 'deviceSettingsBtnTradeInBanner',
    DEVICE_SETTINGS_BTN_FWU: 'deviceSettingsBtnFwu',
    DEVICE_SETTINGS_bTN_CHECK_FW_UPDATES: 'deviceSettingsBtnCheckFwUpdates',
    DEVICE_SETTINGS_BTN_USAGE_STATISTICS: 'deviceSettingsBtnUsageStatistics',
    DEVICE_SETTINGS_LOYALTY_CLUB: 'deviceSettingsLoyaltyClub',
    FWU_ADDITIONAL_STEPS_GUIDE_BTN_BACK: 'fwuAdditionalStepsGuideBtnBack',
    FWU_NOT_NEEDED_GOT_IT_BTN: 'firmwareNotNeededBtnGotIt',
    FWU_BEFORE_START_START_BTN: 'checkFirmwareBtnConfirm',
    FWU_BEFORE_START_CANCEL_BTN: 'checkFirmwareBtnCancel',
    GESTURE_MODE_DOUBLE_TAP_BTN: 'statusGestureDoubleTapBtn',
    GESTURE_MODE_LIFT_UP_BTN: 'statusGestureLiftUpBtn',
    LED_MODE_POPUP: 'ledPopup',
    LED_POPUP_BTN_100: 'ledBtn100',
    LED_POPUP_BTN_50: 'ledBtn50',
    LED_POPUP_BTN_0: 'ledBtn0',
    LEGAL_AND_POLICY_BTN_BACK: 'legalDetailedBtnBack',
    LEGAL_AND_POLICY_POPUP: 'legalAndPolicyPopup',
    LEGAL_DISCLAIMER_BTN_BACKS: 'legalDisclaimerBtnBack',
    LEGAL_DISCLAIMER_BTN_DOCUMENT: 'legalDisclaimerBtnDocument',
    LEGAL_DISCLAIMER_BTN_CONTINUE: 'legalDisclaimerBtnContinue',
    BENEFITS_BTN_STARTED: 'benefitsBtnStarted',
    LOADER_CONTROL: 'loaderControl',
    LOCATE_DEVICE_POPUP: 'locateMyDevicePopup',
    LOCATE_DEVICE_POPUP_BTN_START: 'locateMyDeviceBtnStartLocate',
    LOCATE_DEVICE_POPUP_BTN_STOP: 'locateMyDeviceBtnStopLocate',
    LOCK_POPUP: 'lockPopup',
    LOCK_POPUP_BTN_CANCEL: 'lockBtnCancel',
    LOCK_POPUP_BTN_LOCK: 'lockBtnLock',
    LOCK_BTN_RETURN_TO_SETTINGS: 'lockBtnReturnToSettings',
    LOGIN_BTN_BACK: 'loginBtnBack',
    LOGIN_BTN_LOGIN: 'loginBtnLogin',
    LOGIN_INPUT_PASSWORD: 'loginInputPassword',
    LOGIN_INPUT_USERNAME: 'loginInputUsername',
    LOGIN_TEXT_ERROR: 'loginTextError',
    LOGIN_TEXT_ERROR_REG_EXP: 'loginTextErrorRegExp',
    LOGIN_PAGE: 'LoginPage',
    WELCOME_TEXT_WELCOME: 'welcomeTextWelcome',
    MARKET_BTN_CONFIRM: 'marketSelectBtnConfirm',
    MARKET_DDL_LANGUAGE: 'marketSelectDDLLanguage',
    MARKET_DDL_MARKET: 'marketSelectDDLMarket',
    MARKET_SELECT_PAGE: 'marketSelectPage',
    PAIRING_SEQUENCE_ACTIVATION_PAGE: 'pairingSequenceActivationPage',
    PAIRING_SEQUENCE_BTN_SKIP: 'pairingSequenceBtnSkip',
    PAIRING_SEQUENCE_BTN_SELECT_P1V40: 'pairingSequenceBtnSelectVoyager',
    PAIRING_SEQUENCE_BTN_SELECT_P1V40D: 'pairingSequenceBtnSelectDelta',
    PAIRING_SEQUENCE_BTN_SELECT_P1V40M: 'pairingSequenceBtnSelectCosmos',
    PAIRING_SEQUENCE_BTN_SELECT_VEEV: 'pairingSequenceBtnSelectVeev',
    PAIRING_SEQUENCE_DEVICE_SELECT_PAGE: 'pairingSequenceDeviceSelectPage',
    PAIRING_SEQUENCE_ERROR_SKIP_BTN: 'pairingSequenceErrorBtnSkip',
    PAIRING_SEQUENCE_ERROR_TRY_AGAIN_BTN: 'pairingSequenceErrorBtnTryAgain',
    PAIRING_SEQUENCE_PROGRESS_PAGE: 'pairingSequenceProgressPage',
    PAIRING_SEQUENCE_REGISTERING_PAGE: 'pairingSequenceRegisteringPage',
    PAIRING_SEQUENCE_SKIP_PAGE: 'pairingSequenceSkipPage',
    PAIRING_SEQUENCE_SUCCESSFUL_PAIRED_TITLE: 'pairingSequenceSuccessfullyPairedTextTitle',
    PAIRING_SEQUENCE_TITLE: 'pairingSequenceTitle',
    PAIRING_SKIP_POPUP_CONFIRM_BUTTON: 'pairingSequenceSkipBtnConfirm',
    PAIRING_SKIP_POPUP_CANCEL_BUTTON: 'pairingSequenceSkipBtnCancel',
    PAIRING_SEQUENCE_BTN_PREV_ARROW: 'pairingSequenceBtnPrevArrow',
    PAIRING_SEQUENCE_BTN_NEXT_ARROW: 'pairingSequenceBtnNextArrow',
    PAIRING_SEQUENCE_BTN_NEXT: 'pairingSequenceBtnNext',
    PAIRING_SEQUENCE_ERROR_BTN_TRY_AGAIN_BLE: 'pairingSequenceErrorBtnTryAgainBle',
    PAIRING_SEQUENCE_ERROR_BTN_TRY_AGAIN_USB: 'pairingSequenceErrorBtnTryAgainUSB',
    PAIRING_SEQUENCE_REGISTRATION_FAILED_BTN_CONTACT_US: 'pairingSequenceRegistrationFailedBtnContactUs',
    PAIRING_SEQUENCE_REGISTRATION_FAILED_BTN_FIND_STORE: 'pairingSequenceRegistrationFailedBtnFindStore',
    PAIRING_SEQUENCE_TEXT_REGISTERING_TITLE: 'pairingSequenceTextRegisteringTitle',
    PAIRING_SEQUENCE_TEXT_ACTIVATION_TITLE: 'pairingSequenceTextActivationTitle',
    PAIRING_SEQUENCE_SUCCESSFULLY_PAIRED_BTN_START_PERSONALISING:
        'pairingSequenceSuccessfullyPairedBtnStartPersonalising',
    PAIRING_SEQUENCE_SUCCESSFULLY_PAIRED_BTN_LEARN: 'pairingSequenceSuccessfullyPairedBtnLearn',
    PAIRING_SEQUENCE_SUCCESSFULLY_PAIRED_TEXT_NOTIFIC: 'pairingSequenceSuccessfullyPairedTextNotific',
    PAIRING_SEQUENCE_REGISTRATION_FAILED_BTN_TRY_AGAIN: 'pairingSequenceRegistrationFailedBtnTryAgain',
    PAIRING_SEQUENCE_REGISTRATION_FAILED_BTN_OK: 'pairingSequenceRegistrationFailedBtnOk',
    PAIRING_SEQUENCE_REGISTRATION_FAILED_BTN_TRY_SKIP: 'deviceRegistrationNonMandatoryBtnProceed',
    DEVICE_REGISTRATION_INPUT_DATE: 'deviceRegistrationInputDate',
    DEVICE_REGISTRATION_BTN_CONTINUE: 'deviceRegistrationBtnContinue',
    DEVICE_REGISTRATION_BTN_EXTERNAL_REG: 'deviceRegistrationBtnExternalReg',
    DEVICE_REGISTRATION_BTN_SKIP: 'deviceRegistrationBtnSkip',
    POPUP_COMMON_BTN_CLOSE: 'popupBtnClose',
    PREF_CENTER_BTN_BACK: 'prefCenterBtnBack',
    PREF_CENTER_BTN_SAVE: 'prefCenterBtnSave',
    PREF_CENTER_TOGGLE: 'prefCenterTogle',
    PREFERENCE_CENTER_PAGE: 'preferenceCenterPage',
    QSG_PAGE: 'qsgPage',
    QSG_PAGE_BTN_BACK: 'qsgBtnBack',
    QSG_PAGE_BTN_NEXT: 'qsgBtnNext',
    QSG_PAGE_BTN_PREV: 'qsgBtnPrevious',
    QSG_PAGE_BTN_SKIP: 'qsgBtnSkip',
    REGISTRATION_FAILED_POPUP_BUTTON: 'deviceRegistrationNonMandatoryBtnContactUs',
    RENAME_DEVICE_POPUP: 'renameMyDevicePopup',
    RENAME_DEVICE_POPUP_BTN_CANCEL: 'renameMyDeviceBtnCancel',
    RENAME_DEVICE_POPUP_BTN_CLEAR_INPUT: 'renameMyDeviceBtnClearInput',
    RENAME_DEVICE_POPUP_BTN_OK: 'renameMyDeviceBtnOk',
    RENAME_DEVICE_POPUP_INPUT: 'renameMyDeviceInputDeviceName',
    RENAME_DEVICE_DEFAULT_SELECTED_OPTION: 'renameMyDeviceBtnDefault',
    RENAME_DEVICE_PERSONALIZED_SELECTED_OPTION: 'renameMyDeviceBtnPersonalised',
    RESP_DRAW_POPUP_BTN_BUBBLY: 'responsiveDrawBtnBubbly',
    RESP_DRAW_POPUP_BTN_CRESCENDO: 'responsiveDrawBtnCrescendo',
    RESP_DRAW_POPUP_BTN_DISABLE: 'responsiveDrawBtnOff',
    RESP_DRAW_POPUP_BTN_SIREN: 'responsiveDrawBtnSiren',
    RESP_DRAW_POPUP_BTN_STACCATO: 'responsiveDrawBtnStaccato',
    RESP_DRAW_POPUP_BTN_VIVACE: 'responsiveDrawBtnVivace',
    RESPONSIVE_DRAW_POPUP: 'responsiveDrawPopup',
    SETUP_NEW_IQOS_PAGE: 'setUpNewIqosPopup',
    STATUS_GESTURE_MODE_POPUP: 'statusGesturePopup',
    TERMS_OF_USE_PAGE: 'termOfUsePage',
    TIPS_BTN_GET_STARTED: 'tipsBtnGetStarted',
    TIPS_BTN_PAGER_LAST: 'tipsBtnPagerLast', //TODO: add
    TIPS_TRICKS_PAGE: 'tipsPage',
    TIPS_TUTORIALS_BTN_BACK: 'tipsAndTutorialsBtnBack',
    TIPS_TUTORIALS_BTN_DETAILS_BACK: 'tipsAndTutorialsBtnDetailsBack',
    TIPS_TUTORIALS_BTN_DETAILS_EXPLORE: 'tipsAndTutorialsBtnDetailsExplore',
    TIPS_TUTORIALS_BTN_DETAILS_NEXT: 'tipsAndTutorialsBtnDetailsNext',
    TIPS_TUTORIALS_BTN_DETAILS_NEXT_SECTION: 'tipsAndTutorialsBtnDetailsNextSection',
    TIPS_TUTORIALS_BTN_P1_B: 'tipsAndTutorialsBtnP1Battery',
    TIPS_TUTORIALS_BTN_P1_C: 'tipsAndTutorialsBtnP1Cleaning',
    TIPS_TUTORIALS_BTN_P1_HTU: 'tipsAndTutorialsBtnP1HowToUse',
    TIPS_TUTORIALS_BTN_P1_HT: 'tipsAndTutorialsBtnP1HelpfulTips',
    TIPS_TUTORIALS_BTN_P1_T: 'tipsAndTutorialsBtnP1Tips',
    TIPS_TUTORIALS_BTN_P4_B: 'tipsAndTutorialsBtnP4Battery',
    TIPS_TUTORIALS_BTN_P4_C: 'tipsAndTutorialsBtnP4Cleaning',
    TIPS_TUTORIALS_BTN_P4_HTU: 'tipsAndTutorialsBtnP4HowToUse',
    TIPS_TUTORIALS_BTN_P4_P: 'tipsAndTutorialsBtnP4Pod',
    TIPS_TUTORIALS_BTN_P4_RD: 'tipsAndTutorialsBtnP4ResponsiveDraw',
    TIPS_TUTORIALS_BTN_P4_T: 'tipsAndTutorialsBtnP4Tips',
    TIPS_TUTORIALS_BTN_COSMOS_AF: 'tipsAndTutorialsBtnCosmosAdvancedFeature',
    TIPS_TUTORIALS_PAGE: 'tipsAndTutorialsPage',
    UNLOCK_POPUP: 'unlockPopup',
    UNLOCK_POPUP_BTN_CANCEL: 'unlockBtnCancel',
    UNLOCK_POPUP_BTN_UNLOCK: 'unlockBtnUnlock',
    VAPE_CLOUD_POPUP_BTN_REDUCED: 'VapeCloudSizeBtnReduced',
    VAPE_CLOUD_POPUP_BTN_REGULAR: 'vapeCloudSizeBtnRegular',
    VAPE_CLOUD_SIZE_POPUP: 'vapeCloudSizePopup',
    VERIFY_AGE_BTN_BACK: 'verifyAgeBtnBack',
    VERIFY_AGE_BTN_CONFIRM: 'verifyAgeBtnConfirm',
    VERIFY_AGE_INPUT_DAY: 'verifyAgeInputDay',
    VERIFY_AGE_INPUT_MONTH: 'verifyAgeInputMonth',
    VERIFY_AGE_INPUT_YEAR: 'verifyAgeInputYear',
    VERIFY_AGE_ERROR_YEAR_VALIDATION: 'verifyAgeErrorYearValidation',
    VIBRATION_BTN_DUR_USG_ALMOST_FINISHED: 'vibrationBtnDuringUsageAlmostFinished',
    VIBRATION_BTN_DUR_USG_EXPERIENCE_ENDED: 'vibrationBtnDuringUsageExperienceEnded',
    VIBRATION_BTN_DUR_USG_ORDINARY_HEAT: 'vibrationBtnDuringUsageOrdinaryHeat',
    VIBRATION_BTN_DUR_USG_READY_TO_USE: 'vibrationBtnDuringUsageReadyToUse',
    VIBRATION_BTN_DUR_USG_START_HEATING: 'vibrationBtnDuringUsageStartHitting',
    VIBRATION_BTN_HOLDER_BATTERY_CHARGED: 'vibrationBtnHolderBatteryCharged',
    VIBRATION_BTN_FALSE: 'vibrationBtnFalse',
    VIBRATION_BTN_TRUE: 'vibrationBtnTrue',
    VIBRATION_BUTTON_OFF: 'vibrationBtnOff',
    VIBRATION_BUTTON_CUSTOM: 'vibrationBtnCustom',
    RENAME_MY_DEVICE_SUCCESS_NOTIFICATION: 'renameMyDeviceSuccessNotification',
    DEVICE_SETTINGS_BTN_COUNTDOWN_MODE: 'deviceSettingsBtnCountdownMode',
    COUNTDOWN_MODE_POPUP: 'countdownPopup',
    COUNTDOWN_MODE_DURING_EXP_BTN: 'countdownModeDuringExperienceBtn',
    COUNTDOWN_MODE_FALSE_BTN: 'countdownModeFalseBtn',
    COUNTDOWN_MODE_TRUE_BTN: 'countdownModeTrueBtn',
    TNC_TOU_BTN_AGREE: 'termOfUseBtnAgree',
    TNC_TOU_BTN_DECLINE: 'termOfUseBtnDecline',
    TNC_TOU_BTN_DETAILED: 'termOfUseBtnDetailed',
    TNC_TOU_NOTIFICATION: 'termOfUseNotification',
    LEGAL_DETAILED_BTN_BACK: 'legalDetailedBtnBack',
    TNC_DC_AGREE: 'dataCollectionBtnAgree',
    TNC_DC_DECLINE: 'dataCollectionBtnDecline',
    TNC_DC_PREF_CENTER: 'dataCollectionBtnPrefCenter',
    ABOUT_MY_DEVICE_OFFLINE_NOTIFICATION: 'aboutMyDeviceOfflineNotification',
    RENAME_MY_DEVICE_FAILED_NOTIFICATION: 'renameMyDeviceFailedNotification',
    DEVICE_SETTINGS_RESTART_DEVICE_BTN: 'deviceSettingsRestartDeviceBtn',
    DEVICE_SETTINGS_RESTART_CANCEL_DEVICE_BTN: 'deviceSettingsCancelDeviceBtn',
    DEVICE_SETTINGS_RESET_DEVICE_TEXT_POPUP: 'deviceSettingsRestartDevicePopup',
    DEVICE_SETTINGS_RESET_DEVICE_TEXT_BTN: 'deviceSettingsRestartDeviceBtn',
    DEVICE_SETTINGS_RESET_DEVICE_TEXT_POPUP_ACCEPT_BTN: 'deviceSettingsRestartDevicePopupAcceptBtn',
    DEVICE_SETTINGS_RESET_DEVICE_TEXT_POPUP_CANCEL_BTN: 'deviceSettingsRestartDevicePopupCancelBtn',
    DEVICE_SETTINGS_USAGE_BTN: 'deviceSettingsUsageBtn',
    DEVICE_SETTINGS_BTN_VAPE_SESSION: 'deviceSettingsBtnVapeSession',
    VAPE_SESSION_POPUP: 'vapeSessionPopup',
    VAPE_SESSION_BTN_SAVE_CHANGES: 'vapeSessionBtnSaveChanges',
    VERIFY_AGE_INPUT_ALL: 'VerifyAgeInputAll',
    USAGE_STATS_DISCLAIMER_BTN_BACK: 'usageStatsDisclaimerBtnBack',
    USAGE_CONSENT_PAGE_BLOCKER_BTN_BACK: 'usageConsentPageBlockerBtnBack',
    PURCHASE_DATE_BTN_LATER: 'purchaseDateBtnLater',
    DEVICE_LIST_BTN_PAIRING_INFO_POPUP_CANCEL: 'deviceListBtnPairingInfoPopupCancel',
    ABOUT_MY_DEVICE_TEXT_FW_LATEST_VERSION: 'aboutMyDeviceTextFWLatestVersion',
    PROMOTED_REGISTRATION_NOTIFICATION: 'promotedRegistrationNotification',
    LEVIA_GET_STARTED_NOTIFICATION: 'leviaGetStartedNotification',
    ONBOARD_LEVIA_BTN_LEARN_MORE: 'onboardLeviaBtnLearnMore',
    ONBOARD_LEVIA_BTN_NOT_NOW: 'onboardLeviaBtnNotNow',
    ONBOARD_LEVIA_BTN_CHECK: 'onboardLeviaBtnCheck',
    ONBOARD_LEVIA_BTN_UPDATE: 'onboardLeviaBtnUpdate',
    DEVICE_SETTINGS_BTN_FIRMWARE_UPDATE: 'deviceSettingsBtnFirmwareUpdate',
    FIRMWARE_BTN_START_UPDATE: 'firmwareBtnStartUpdate',
    FIRMWARE_BTN_BACK_TO_SETTINGS: 'firmwareBtnBackToSettings',
    FIRMWARE_BTN_CONFIRM_START_UPDATE: 'firmwareBtnConfirmStartUpdate',
    FIRMWARE_BTN_RECONNECT: 'firmwareBtnReconnect',
    FIRMWARE_BTN_CONTINUE: 'firmwareBtnContinue',
    FIRMWARE_BTN_CANCEL: 'firmwareBtnCancel',
    FIRMWARE_BTN_TRY_AGAIN: 'firmwareBtnTryAgain',
    FIRMWARE_BTN_FAIL_CANCEL: 'firmwareBtnFailCancel',
    FIRMWARE_SUCCESS_BTN_BACK_TO_SETTINGS: 'firmwareSuccessBtnBackToSettings',
    ADVANCED_DIAGNOSTIC_ENTRY_BTN_START: 'ADEntryBtnStart',
    ADVANCED_DIAGNOSTIC_PHASE1_QUEST1_BTN_NONE: 'ADPhase1Quest1BtnNone',
    ADVANCED_DIAGNOSTIC_PHASE1_QUEST2_BTN_NONE: 'ADPhase1Quest2BtnNone',
    ADVANCED_DIAGNOSTIC_PHASE2_START_BTN_START: 'ADPhase2StartBtnStart',
    ADVANCED_DIAGNOSTIC_PHASE2_START_BTN_CANCEL: 'ADPhase2StartBtnCancel',
    ADVANCED_DIAGNOSTIC_PHASE2_NO_ERRORS_BTN_FW_NOT_NOW: 'ADPhase2NoErrorsBtnFwNotNow',
    ADVANCED_DIAGNOSTIC_PHASE2_NO_ERRORS_BTN_FW_UPDATE: 'ADPhase2NoErrorsBtnFwUpdate',
    ADVANCED_DIAGNOSTIC_PHASE1_QUEST1_BTN_BACK: 'ADPhase1Quest1BtnBack',
    ADVANCED_DIAGNOSTIC_PHASE1_QUEST2_BTN_BACK: 'ADPhase1Quest2BtnBack',
    ADVANCED_DIAGNOSTIC_PHASE1_QUEST1_BTN_SELECT: 'ADPhase1Quest1BtnSelect',
    ADVANCED_DIAGNOSTIC_BTN_LEFT_ARROW: 'ADBtnLeftArrow',
    ADVANCED_DIAGNOSTIC_BTN_RIGHT_ARROW: 'ADBtnRightArrow',
    ADVANCED_DIAGNOSTIC_BTN_PAGER: 'ADBtnPager',
    ADVANCED_DIAGNOSTIC_BTN_FIND_STORE: 'ADBtnFindStore',
    ADVANCED_DIAGNOSTIC_BTN_CONTACT_US: 'ADBtnContactUs',
    ADVANCED_DIAGNOSTIC_BTN_LATER: 'ADBtnLater',
    ADVANCED_DIAGNOSTIC_BTN_DEVICE_DETAILS: 'ADBtnDeviceDetails',
    ADVANCED_DIAGNOSTIC_PHASE1_QUEST2_BTN_OPTION: 'ADPhase1Quest2BtnOption',
    ADVANCED_DIAGNOSTIC_PHASE1_QUEST3_BTN_YES: 'ADPhase1Quest3BtnYes',
    ADVANCED_DIAGNOSTIC_PHASE1_QUEST3_BTN_NO: 'ADPhase1Quest3BtnNo',
    ADVANCED_DIAGNOSTIC_PHASE1_HOLDER_CHARGE_BTN_CLEAN: 'ADPhase1HolderChargeBtnClean',
    ADVANCED_DIAGNOSTIC_PHASE1_HOLDER_CHARGE_BTN_NOT_NOW: 'ADPhase1HolderChargeBtnNotNow',
    CLEANING_GUIDE_BTN_FINISH: 'cleaningGuideBtnFinish',
    CLEANING_GUIDE_BTN_PAGER: 'cleaningGuideBtnPager',
    DEVICE_SECURITY_CONSENT_BTN_AGREE: 'deviceSecurityConsentBtnAgree',
    DEVICE_SECURITY_CONSENT_BTN_DECLINE: 'deviceSecurityConsentBtnDecline',
    DEVICE_SECURITY_CONSENT_PAGE: 'deviceSecurityConsentPage',
};
